const toPriceNumber = (input) => {
  return isNaN(input) ? null : input.toFixed(2);
};

export { toPriceNumber };
